<template>
  <div v-if="has_active_filters" class="active-filters">
    <div class="active-filters__header">
      <span class="active-filters__title">Filtri attivi:</span>
      <span
        class="active-filters__reset text--sm text-info underline cursor-pointer"
        @click="$emit('reset')"
      >
        cancella filtri
      </span>
    </div>

    <div class="active-filters__list">
      <b-badge
        v-if="availability_active"
        pill
        variant="primary"
        class="active-filters__chip semibold d-inline-flex mr-1 mb-1 cursor-pointer"
        @click="$emit('availability', false)"
      >
        <span>Mostra in base al credito</span>
        <span class="ml-2">&#10005;</span>
      </b-badge>

      <template v-for="group in ordered_filters">
        <template v-for="(option, option_index) in group.options">
          <b-badge
            v-if="option.selected"
            :key="`${group.key}-${option_index}`"
            pill
            variant="primary"
            class="active-filters__chip semibold d-inline-flex mr-1 mb-1 cursor-pointer"
            @click="clear(group.key, option)"
          >
            <span class="active-filters__chip-text">
              {{ option.text.toLowerCase() }}
            </span>
            <span class="ml-2">&#10005;</span>
          </b-badge>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  import {
    get_non_brand_filters,
    has_active_filters,
  } from '@alpitour/utilities/results-filters';

  export default {
    name: 'active-filters',

    props: {
      filters: {
        type: Object,
        default: () => ({}),
      },
      availability_active: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ordered_filters() {
        const groups = [];
        if (this.filters.brand) {
          groups.push({ key: 'brand', options: this.filters.brand });
        }
        Object.entries(get_non_brand_filters(this.filters)).forEach(
          ([key, options]) => groups.push({ key, options }),
        );
        return groups;
      },
      has_active_filters() {
        return has_active_filters(this.filters, this.availability_active);
      },
    },

    methods: {
      clear(key, option) {
        option.selected = false;
        this.$emit('filter', { key, value: false });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .active-filters {
    margin-bottom: $grid-gutter-width / 2;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: $grid-gutter-width / 3;
      margin-bottom: $grid-gutter-width / 3;
    }

    &__title {
      font-size: $font-size-base;
      font-weight: $vb-font-weight-semibold;
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
    }

    &__chip-text {
      text-transform: capitalize;
    }
  }
</style>
